import {gql} from 'apollo-angular';
import { Page } from '../../entities/page/page';
import { Issue } from '../../entities/issue/issue';
import { Label } from '../../entities/label/label';

export const ISSUES_QUERY = gql`
query issuesQuery(
  $typeCodes: [String],
  $states: [String],
  $assigneeIds: [String],
  $locationIds: [UUID],
  $binaryStatus: String,
  $inwardEntityType: String,
  $inwardEntityId: UUID,
  $text: String,
  $fromDueDateTime: String,
  $toDueDateTime: String,
  $includeOverdue: Boolean,
  $labelIds: [UUID],
  $number: Int,
  $size: Int,
  $sortProperty: String,
  $sortDirection: String
)
{
  issues: getIssuesPaged(
    filter: {
      sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
      pagination: { number: $number, size: $size,  sortProperty: $sortProperty, sortDirection: $sortDirection},
      typeCodes: $typeCodes,
      states: $states,
      assigneeIds: $assigneeIds,
      locationIds: $locationIds,
      binaryStatus: $binaryStatus,
      inwardEntityType: $inwardEntityType,
      inwardEntityId: $inwardEntityId,
      text: $text,
      fromDueDateTime: $fromDueDateTime,
      toDueDateTime: $toDueDateTime,
      includeOverdue: $includeOverdue,
      labelIds: $labelIds
    }
  ){
    totalPages
    totalElements
    number
    size
    content {
      id
      title
      number
      dueDateTime
      assignee{
        id
        firstName
        lastName
      }
      labels{
        name
        color
        scope
      }
      issueStatus{
        id
        code
        label
        roles
        color
        statusGroup{
          code
          binaryStatusLabel
          isOpen
        }
      }
      issueType{
        code
        name
        prefix
        icon
        color
      }
      assignee{
        id
        firstName
        lastName
      }
      createdBy{
        id
        firstName
        lastName
      }
      createdDateTime
      lastModifiedDateTime
      noteCount
      fileCount
      location{
        name
      }
    }
  }
  getLabels(filter: { }) {
    id
    externalId
    name
    scope
    color
    description
  }
}
`;

export interface IssuesQueryResponse {
  issues: Page<Issue>;
  loading: boolean;
  getLabels: Label[];
}
